<template>
    <div class="employee-certification">
        <ul class="uk-tab" uk-switcher="">
            <li class="uk-active"><a href="#employee-certification-current">Current</a></li>
            <li><a href="#employee-certification-archive">Archive</a></li>
        </ul>
        <ul class="uk-switcher">
            <li class="uk-container uk-container-expand">
                <div v-for="cert in certifications" class="uk-grid uk-margin-small-top uk-margin-small-bottom uk-margin-small-right employee-certification-row">
                    <div class="uk-width-4-5">
                        <input class="uk-input" disabled :value="certificationString(cert)"  />
                        <span v-if="cert.expires_soon" class="warning-icon"><i class="fas fa-exclamation-triangle"></i></span>
                        <span uk-form-custom>
                            <input :id="'cert-upload-' + cert.id" type="file" multiple @change="uploadCertificationFile($event, cert)" />
                        </span>
                    </div>
                    <div class="uk-width-1-5 controls">
                        <a href="#" :uk-toggle="'target: #' + viewModalId" @click="activateViewModal(cert.id)"><i class="fas fa-search"></i></a>
                        <a href="#" :uk-toggle="'target: #' + formModalId" @click="activateEditModal(cert.id)"><i class="fas fa-edit"></i></a>
                        <label :for="'cert-upload-' + cert.id" class="upload-link"><i class="fas fa-upload"></i></label>
                        <a href="#" :uk-toggle="'target: #' + deleteModalId"  @click="activateDeleteModal(cert.id)"><i class="fas fa-trash"></i></a>
                    </div>
                </div>
                <div class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right">
                    <a :uk-toggle="'target: #' + formModalId"><i class="fas fa-plus-circle"></i> Add Another Certification</a>
                </div>
            </li>
            <li class="uk-container uk-container-expand">
                <div v-for="cert in archives" class="uk-grid uk-margin-small-top uk-margin-small-bottom uk-margin-small-right employee-certification-row">
                    <div class="uk-width-4-5">
                        <input class="uk-input" disabled :value="certificationString(cert)"  />
                        <div uk-form-custom>
                            <input :id="'cert-upload-' + cert.id" type="file" multiple @change="uploadCertificationFile($event, cert)" />
                        </div>
                    </div>
                    <div class="uk-width-1-5 controls">
                        <a href="#" :uk-toggle="'target: #' + viewModalId" @click="activateViewModal(cert.id)"><i class="fas fa-search"></i></a>
                        <a href="#" :uk-toggle="'target: #' + formModalId" @click="activateEditModal(cert.id)"><i class="fas fa-edit"></i></a>
                        <label :for="'cert-upload-' + cert.id" class="upload-link"><i class="fas fa-upload"></i></label>
                        <a href="#" :uk-toggle="'target: #' + deleteModalId"  @click="activateDeleteModal(cert.id)"><i class="fas fa-trash"></i></a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import Moment from "moment";
    export default {
        name: "EmployeeCertification",

        props: {
            uid:Number,
            formModalId:String,
            formRef:String,
            viewModalId:String,
            viewRef:String,
            deleteModalId:String,
            deleteFormRef:String
        },

        data() {
            return {
                certifications:[],
                archives:[]
            };
        },
        mounted() {
            this.loadCertifications();
        },
        methods:{
            loadCertifications(){
                axios.get("/api/employee/get/" + this.uid + "/certification/list")
                    .then((pack) => this.updateCertifications(pack));
                axios.get("/api/employee/get/" + this.uid + "/certification/expired")
                    .then((pack) => this.updateArchives(pack));
            },
            startSearch(){//alias for other items that call this function
                this.loadCertifications();
            },
            updateCertifications(pack){
                this.certifications = pack.data.data;
            },
            updateArchives(pack){
                this.archives = pack.data.data;
            },
            activateEditModal(id){
                this.$root.$refs[this.formRef].loadForm(id);
            },
            activateViewModal(id){
                this.$root.$refs[this.viewRef].loadForm(id);
            },
            activateDeleteModal(id){
                this.$root.$refs[this.deleteFormRef].loadForm(id);
            },
            uploadCertificationFile(event, cert){
                let formData = new FormData();

                for(let i = 0; i < event.target.files.length;++i){
                    formData.append("file" + i, event.target.files[i]);
                }

                axios.post("/api/employee/"+this.uid+"/certification-file/" + cert.id, formData)
                    .then(() => this.loadCertifications());
            },
            formatDate(dateString){
                let date = new Moment(dateString);
                return date.format("MM/DD/YYYY");
            },
            certificationString(cert){
                if(cert.certified){
                    if(cert.expiration){
                        return cert.name + " • " + this.formatDate(cert.certified) + " - " + this.formatDate(cert.expiration);
                    } else {
                        return cert.name + " • " + this.formatDate(cert.certified);
                    }
                } else {
                    return cert.name;
                }

            }
        }
    }
</script>

<style scoped>

</style>
